import axios from 'axios';
import { getOktaAuth, isOktaConfigured } from '../config/auth';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3010/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  async (config) => {
    if (!isOktaConfigured()) return config;
    try {
      const oktaAuth = getOktaAuth();
      const token = await oktaAuth.getAccessToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch {
      // Okta singleton init failed; leave request unauthenticated so backend
      // produces a clean 401 rather than a confusing network error.
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // A 401 from the API means the Okta session is gone or the token was
    // rejected. Let RequireAuth re-trigger signInWithRedirect on the next
    // navigation; avoid doing it here to prevent redirect loops during
    // background fetches.
    return Promise.reject(error);
  }
);

export default api;
